/**
 * Copyright (C) Siemens AG 1996-2026 ALL RIGHTS RESERVED.
 *
 * Resolves the base URL the webapp uses for backend API calls.
 *
 * With `BP_SAME_ORIGIN_API=true` the APIs are requested on the page origin
 * (`https://<portal or brand host>/<service>/…`) and routed to the backend by the
 * CloudFront same-host API origin. This removes every cross-origin request and allows the
 * ALB behind `apps-<env>` to be closed for direct traffic. Without the flag the
 * environment-specific ALB host is used (legacy behaviour).
 *
 * The page origin is only used when it is HTTPS. CloudFront serves the portal and the brand
 * hosts `https-only`, so a non-HTTPS origin means the bundle runs outside its intended edge
 * (local `http://` serve, TLS-terminating misconfiguration); in that case the always-HTTPS
 * ALB URL is kept so bearer tokens are never sent in cleartext.
 */

/**
 * @param {string | undefined} sameOriginFlag - Value of the `BP_SAME_ORIGIN_API` build variable.
 * @param {string} albBaseUrl - Environment-specific ALB origin, e.g. `https://apps-dev.dev.battery-passport.siemens.cloud`.
 * @param {string} [origin] - Page origin; defaults to `window.location.origin`.
 * @returns {string} Origin to prefix the service paths with (never ends with a slash).
 */
export function resolveApiBaseUrl(
  sameOriginFlag: string | undefined,
  albBaseUrl: string,
  origin: string = window.location.origin,
): string {
  const useSameOrigin =
    sameOriginFlag === 'true' && origin.startsWith('https://');
  return useSameOrigin ? origin : albBaseUrl;
}
